export const API_HOST = 'https://api.colzones.com/';
